import Vue from 'vue';

export default {
	login(code) {
		var params = { code };

		var url = '/login';
		var self = this;
		return this.post(url, params).then((response) => {
			self.postLoginSuccess(response.data);
		});
	},

	tokenLogin(token) {
		var params = { token };

		var url = '/login/token';
		var self = this;
		return this.post(url, params).then((response) => {
			self.postLoginSuccess(response.data);
		});
	},

	postLoginSuccess(data) {
		var token = data.token;
		this.updateSessionStorage(token);
		this.setupCommonHeaders(token);

		// global access to customers and customer projects
		Vue.prototype.$customer = data.customer;
		Vue.prototype.$customerprojects = data.customerProjects;

		return true;
	},

	logout() {
		var url = '/logout';
		var self = this;
		return this.delete(url).then(() => {
			self.postLogoutSuccess();
		})
	},

	postLogoutSuccess() {
		delete sessionStorage.cdn_token;
		this.clearCommonHeaders();
	},

	get(url) {
		return this.doHttpRequest('get', url);
	},

	post(url, params) {
		return this.doHttpRequest('post', url, params);
	},

	postDocument(url, params, headers) {
		return this.doHttpRequest('post', url, params, headers)
	},

	put(url, params) {
		return this.doHttpRequest('put', url, params);
	},

	delete(url, params) {
		return this.doHttpRequest('delete', url, params);
	},

	doHttpRequest(type, url, params, headers) {
		url = url.replace(/^\//g, '');
		var requestUrl = `${this.cdnConfig().backendUrl}/${url}`;
		if (!headers) headers = { 'Content-Type': 'application/json' };
		var options = { headers }
		try {
			var request = this.httpClient()[type];
			return request(requestUrl, params, options);
		} catch (e) {
			console.error('could not perform http request');
		}
	},

	setupCommonHeaders(token) {
		var commonHeaders = Vue.prototype.$http.defaults.headers.common;
		if (token) commonHeaders['API-Token'] = token;
		Vue.prototype.$http.defaults.common = commonHeaders;
	},
	clearCommonHeaders() {
		var commonHeaders = Vue.prototype.$http.defaults.headers.common;
		delete commonHeaders['API-Token'];
		Vue.prototype.$http.defaults.common = commonHeaders;
	},

	updateSessionStorage(token) {
		try {
			if (sessionStorage.cdn_token && sessionStorage.cdn_token !== token) { sessionStorage.clear(); }
			if (token) sessionStorage.cdn_token = token;
		} catch (e) {
			console.error('could not access SessionStorage to store login credentials', e);
		}
	},

	// utility
	httpClient() { return Vue.prototype.$http; },
	cdnConfig() { return Vue.prototype.$cdnConfig; },
	paramStr(params) {
		return new URLSearchParams(params).toString();
	},
};
